<template>
  <v-content>
    <v-container fluid>
      <OLoadingDialog :value="isLoading" />
      <TokenDetailsDialog ref="detailsDialog" />

      <v-card>
        <v-toolbar flat class="card-bar">
          <v-toolbar-title>Tokens</v-toolbar-title>
          <v-btn icon @click="reload" class="ml-2">
            <v-icon>refresh</v-icon>
          </v-btn>
          <v-spacer />
        </v-toolbar>

        <OPaginatedTable
          :spec="spec"
          :items="rows"
          :count="count"
          :navigation="nav"
          @update:navigation="v => (nav = v)"
          noData="Não existem registros para o filtro informado."
          @rowClicked="showDetailsDialog"
        />
      </v-card>
    </v-container>
  </v-content>
</template>

<script>
import { Token } from '@/models'
import { brLongDateTime } from 'oderon-commons/src/formatters'

function greyText(x) {
  return { html: `<span class="grey--text text--lighten-1">${x}</span>` }
}

function mono(x) {
  return { html: `<span class="mono">${x}</span>` }
}

export default {
  components: {
    OLoadingDialog: require('oderon-vue/cpts/OLoadingDialog').default,
    OPaginatedTable: require('oderon-vue/cpts/OPaginatedTable').default,
    TokenDetailsDialog: require('./TokenDetailsDialog').default
  },
  data() {
    return {
      isLoading: false,

      spec: [
        { t: 'ID|', d: 'id', f: greyText },
        { t: 'Code', d: 'code', f: mono },
        { t: 'Subject', d: 'subject' },
        { t: 'App', d: 'app' },
        { t: 'Created|', d: 'createdAt', f: brLongDateTime },
        { t: 'Expires|', d: 'expiresAt', f: brLongDateTime }
      ],

      count: null,
      nav: {
        offset: 0,
        limit: 20
      },

      rows: []
    }
  },
  watch: {
    nav() {
      this.reload()
    }
  },
  mounted() {
    this.reload()
  },
  methods: {
    reload() {
      this.$loading(() => this.fetchData())
    },

    reloadFromStart() {
      this.nav.offset = 0
      this.reload()
    },

    async fetchData() {
      let { limit, offset } = this.nav
      let res = await Token.findAll({ limit, offset })
      this.rows = res.rows
      this.count = res.count
    },

    async showDetailsDialog(row) {
      let res = await this.$refs.detailsDialog.open(row.code)
      if (res === 'DELETE') {
        this.$loading(() => this.deleteRow(row))
      }
    },

    async deleteRow(row) {
      await Token.delete(row.code)
      await this.fetchData()
      this.$snack('Removido com sucesso')
    }
  }
}
</script>

<style></style>
